const defaultTheme = {
  primary: "#252f4a",
  fontColor: "#ffffff",
  backgroundColor: "linear-gradient(to right, #252f4a, #3d476a)",
  background: {
    gradient: "linear-gradient(to right, #3ab1e6 , #b63e8f 90%)",
    fieldColor: "linear-gradient(108deg, #e73cde, #49b4e6)",
    button: "linear-gradient(to right, #3ab1e6, #b63e8f 90%)",
    sponsors: "linear-gradient(to right, #b5bed4, #ffffff 55%)",
  },
  button: {
    gradient: "linear-gradient(to right, #3ab1e6 , #b63e8f 90%)",
    color: "#3ab1e6",
    font: {
      color: "#ffffff"
    }
  },
  divider: {
    color: "white"
  },
  image: {
    filter: "invert(100%);" // Should display icons as black.
  },
  opacity: 0.5,
  letterSpacing: "1px",
  breakpoints: {
    xs: "0",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px"
  },
  breakpointsNo: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  media: {
    minWidthXs: `(min-width: 0)`,
    minWidthSm: `(min-width: 576px)`,
    minWidthMd: `(min-width: 768px)`,
    minWidthLg: `(min-width: 992px)`,
    minWidthXl: `(min-width: 1200px)`
  }
};

const swissTheme = {
  ...defaultTheme,
  primary: "#ffffff",
  fontColor: "#000000",
  backgroundColor: "linear-gradient(to right, #ffffff, #ffffff)",
  background: {
    gradient: "linear-gradient(to right, #fc0 , #fc0)",
    fieldColor: "linear-gradient(to right, #ffee88, #fc0)",
    button: "linear-gradient(to right, #fc0, #fc0)",
    sponsors: "linear-gradient(to right, #ffffff, #ffffff)",
  },
  button: {
    gradient: "linear-gradient(to right, #fc0 , #fc0 90%)",
    color: "#fc0",
    font: {
      color: "#000000"
    }
  },
  image: {
    filter: "invert(0%);" // Should display icons as white.
  },
  divider: {
    color: "black"
  },
};

export {defaultTheme, swissTheme};
